import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IndividuService } from '@Common/core/services';
import { Observable } from 'rxjs';


@Injectable()
export class GestionnaireGuardService  {
  constructor(private individuService: IndividuService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isGestionnaire();
  }

  private isGestionnaire(): Observable<boolean> {
    return Observable.create(observer => {
      this.individuService.individu$.subscribe(_individu => {
          observer.next(this.isStaff(_individu));
          // observer.next(this.individuService.hasRole(_individu, 'supergestionnaire_bdc'));
          observer.complete();
        }
      );
    });
  }

  private isStaff(individu) {
    if (this.individuService.hasRole(individu, 'admin_bdc') ||
      this.individuService.hasRole(individu, 'supergestionnaire_bdc') || this.individuService.hasRole(individu, 'gestionnaire_bdc')) {
      return true;
    } else {
      return false;
    }
  }
}
